import { ValueType } from 'rsuite/esm/Checkbox';
import {
  getAdminConsultantRegister,
  getAdminConsultantsRegisters,
  getConsultantRequest,
  getConsultantsRequests,
  postAdminConsultantRegister,
  postAdminLoginWithPassword,
  putAcceptConsultant,
  putAdminConsultantRegister
} from '../core/admin';
import { showToast } from '../utils/toast';
import { AdminConsultantRegisterModel } from '../models/admin';
import { postAddRoleToUser } from '../core';

export const handleAcceptConsultant = async (
  accept: ValueType,
  username: string,
  whyReject: string,
  wasAccepted: boolean
) => {
  try {
    const { data, status } = await putAcceptConsultant(accept, username, whyReject);
    if (status === 200) {
      if (accept === 'Accepted' && !wasAccepted) {
        // handle if accepted twice from backend too
        console.log('asadaasasd');
        await postAddRoleToUser('Consultant', username);
      } else {
        // todo
        // await deleteRoleFromUser('Consultant', username);
      }
      console.log(data);
      return { data, ok: true };
    } else {
      showToast(data.Message, 'error');
    }
    console.log('NOT 200', data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    console.log(e);
    showToast(e.response?.data?.Message.FA ?? 'مشکلی پیش آمده!', 'error');
  }
  return { ok: false };
};

export const handleGetConsultantsRequests = async () => {
  try {
    const { data, status } = await getConsultantsRequests();
    if (status === 200) {
      console.log(data);
      return { data: data.Data, ok: true };
    } else {
      showToast(data.Message, 'error');
    }
    console.log('NOT 200', data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    console.log(e);
    showToast(e.response?.data?.Message.FA ?? 'مشکلی پیش آمده!', 'error');
  }
  return { ok: false };
};

export const handleGetConsultantRequest = async (username: string) => {
  try {
    const { data, status } = await getConsultantRequest(username);
    if (status === 200) {
      console.log(data);
      return { data: data.Data, ok: true };
    } else {
      showToast(data.Message, 'error');
    }
    console.log('NOT 200', data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    console.log(e);
    showToast(e.response?.data?.Message.FA ?? 'مشکلی پیش آمده!', 'error');
  }
  return { ok: false };
};

export const handleGetAdminConsultantsRegisters = async () => {
  try {
    const { data, status } = await getAdminConsultantsRegisters();
    // return { ok: true, payload };
    if (status === 200) {
      console.log(data);
      return { data: data.Data, ok: true };
    } else {
      showToast(data.Message, 'error');
      return { data: data.Data, ok: false };
    }
    console.log('NOT 200', data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (e.response?.status === 404) {
      console.log('not submitted');
      return { data: {}, ok: false };
    }
    console.log(e.response?.data?.Message.FA);
    showToast(e.response?.data?.Message.FA ?? 'مشکلی پیش آمده!', 'error');
  }
  return { ok: false };
};
export const handleGetAdminConsultantRegister = async (username: string) => {
  try {
    const { data, status } = await getAdminConsultantRegister(username);
    // return { ok: true, payload };
    if (status === 200) {
      console.log(data);
      return { data: data.Data, ok: true };
    } else {
      showToast(data.Message, 'error');
      return { data: data.Data, ok: false };
    }
    console.log('NOT 200', data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (e.response?.status === 404) {
      console.log('not submitted');
      return { data: {}, ok: false };
    }
    console.log(e.response?.data?.Message.FA);
    showToast(e.response?.data?.Message.FA ?? 'مشکلی پیش آمده!', 'error');
  }
  return { ok: false };
};
export const handlePostAdminConsultantRegister = async (payload: AdminConsultantRegisterModel) => {
  try {
    const { data, status } = await postAdminConsultantRegister(payload);
    if (status === 200) {
      console.log(data);
      return { data, ok: true };
    } else {
      showToast(data.Message, 'error');
    }
    console.log('NOT 200', data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    console.log(e);
    showToast(e.response?.data?.Message.FA ?? 'مشکلی پیش آمده!', 'error');
  }
  return { ok: false };
};
export const handlePutAdminConsultantRegister = async (payload: AdminConsultantRegisterModel) => {
  try {
    const { data, status } = await putAdminConsultantRegister(payload);
    if (status === 200) {
      console.log(data);
      return { data, ok: true };
    } else {
      showToast(data.Message, 'error');
    }
    console.log('NOT 200', data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    console.log(e);
    showToast(e.response?.data?.Message.FA ?? 'مشکلی پیش آمده!', 'error');
  }
  return { ok: false };
};
// admin
export const handleAdminLoginWithPassword = async (username: string, password: string) => {
  try {
    const { data, status } = await postAdminLoginWithPassword(username, password);
    if (status === 200) {
      console.log(data);
      return { data, ok: true };
    } else {
      showToast(data.Message, 'error');
    }
    console.log('NOT 200', data);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    console.log(e.response?.data.Message.FA);
    showToast(e.response?.data.Message.FA ?? 'مشکلی پیش آمده!', 'error');
  }
  return { ok: false };
};
